




















































































































































import FooterButton from "@/components/FooterButton.vue";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { AppData, CareGiver } from "@/models/app-data";
import { required, email} from "vuelidate/lib/validators";
import CommonMixin from "@/mixins/common-mixins";
import { WorkflowService } from "@/service/workflow.service";
import { ContentService } from "@/service/content.service";
import { CommonFormBuilder } from "@/utils/common-form-builder";
import { CareGiver1Content } from "@/models/content/caregiver-1";
import VueRecaptcha from "vue-recaptcha";

@Component({
  components: {
    FooterButton,
    VueRecaptcha
  },
  validations: {
    lastName: {
      required
    },
    firstName: {
      required
    },
    phoneNumber: {
      required,
      validPhone(value: string): boolean {
        const regex = new RegExp(/^\d{3}-\d{3}-\d{4}$/);
        return regex.test(value);
      }
    },
    email: {
      email,
      required 
    },
    confirmEmail: {
      emailsMatch(value: string): boolean {
        const model = this as CareGiver1
        return model.email === model.confirmEmail;
      }
    }
  }
})
export default class CareGiver1 extends Mixins(CommonMixin) {
  workflowService = new WorkflowService();
  commonFormBuilder = new CommonFormBuilder();
  content: CareGiver1Content = {} as CareGiver1Content;
  PercentDone = 10;
  appData = {} as AppData;
  lastName = "";
  firstName = "";
  preferredName = "";
  phoneNumber = "";
  email = "";
  confirmEmail = "";
  IsSaving = false;
  textDirection = 'ltr'
  language!: string

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getCareGiver1Content();
      this.textDirection = contentService.TextDirection();
      this.language = contentService.Language();

      await this.loadData();
      if (this.appData != null) {
        if (this.appData.careGiver != null) {
          this.lastName = this.appData.careGiver.lastName;
          this.firstName = this.appData.careGiver.firstName;
          this.preferredName = this.appData.careGiver.preferredName;
          this.phoneNumber = this.appData.careGiver.phoneNumber;
          this.email = this.appData.careGiver.email;
          this.confirmEmail = this.appData.careGiver.email;
        }
        this.putWorkflowStep( this.appData.workflowId, "CareGiver1") 
      }
    } catch (error) {
      this.showError(error);
    }
  }

  async loadData(): Promise<void> {
    if (this.$route?.query?.workflowid != null) {
      const workflowId = this.$route.query.workflowid + "";
      const appData = await this.workflowToAppData(workflowId);
      this.saveAppData(appData);
      this.appData = appData;
    } else {
      this.appData = this.getAppData();
    }
  }

  public async handleNextPageEvent(): Promise<void> {
    this.IsSaving = true;
    this.TheCapcha.execute();
  }

  async saveData(capchaToken: string): Promise<void> {
    try {
      if (this.appData == null) {
        this.appData = {} as AppData;
      }
      if (this.appData.careGiver == null) {
        this.appData.careGiver = {} as CareGiver;
      }
      this.appData.careGiver.lastName = this.lastName;
      this.appData.careGiver.firstName = this.firstName;
      this.appData.careGiver.preferredName = this.preferredName;
      this.appData.careGiver.phoneNumber = this.formatPhoneNumberForSaving();
      this.appData.careGiver.email = this.email;
      this.saveAppData(this.appData);
      const commonForm = await this.commonFormBuilder.BuildCommonForm(
        this.appData,
        capchaToken
      );
      await this.createCommonForm(commonForm);
    } catch (err) {
      this.showError(err);
    }
  }

  @Watch("phoneNumber")
  onPropertyChanged(value: string) {
    if (value != null) {
      // only allow numbers, (,), and -
      // this.phoneNumber = value.replace(/[^0-9]/g, '')
      // Once we have 10 numbers, format the number to (###) ###-####
      const numbersOnly = value.replace(/\D/g, "");
      if (numbersOnly.length == 10) {
        this.phoneNumber = numbersOnly
          .replace(/[^0-9()-]/g, "")
          .replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
      }
    }
  }
    
  formatPhoneNumberForSaving(): string {
    const numbersOnly = this.phoneNumber.replace(/\D/g, "");
    return numbersOnly;
  }

  // For phone number validation
  disableNext(): boolean {
    return this.$v.$invalid || this.IsSaving === true;
  }

  get TheCapcha(): any {
    return this.$refs.captcharef;
  }

  async onVerifyCaptcha(captchaToken: string) {
    this.TheCapcha.reset();
    try {
      await this.saveData(captchaToken);
      this.$router.push({ path: "CareGiver2" });
    } catch (err) {
      this.IsSaving = false;
      this.showError(err);
    }
  }

  onExpiredCaptcha(): void {
    this.TheCapcha.reset();
  }

  onErrorCaptcha(): void {
    if (this.IsSaving === true) {
      this.IsSaving = false;
      this.showError("Captcha Error");
    }
  }
}
